import axios from "axios";
import { addItem, getItem } from "./LocalStorage";
import { hasAuthentificated, logout } from "./Auth__Service";

export const LOCAL_STORAGE_NAME = process.env.REACT_APP_LOCAL_STORAGE_NAME;
export const API_URL = process.env.REACT_APP_API_URL;
export const URL_CLIENT = process.env.REACT_APP_URL_CLIENT;
export const URL_SALARIE = process.env.REACT_APP_URL_SALARIE;
export const URL_SALARIE_SAVE_MANY =
  process.env.REACT_APP_URL_SALARIE_SAVE_MANY;
export const URL_DOCUMENT = process.env.REACT_APP_URL_DOCUMENT;
export const URL_DOCUMENT_SAVE_MANY =
  process.env.REACT_APP_URL_DOCUMENT_SAVE_MANY;
export const URL_DOWNLOAD_FILE = process.env.REACT_APP_URL_DOWNLOAD_FILE;
export const URL_LOGIN = process.env.REACT_APP_URL_LOGIN;
export const URL_FORGOT_PASSWORD = process.env.REACT_APP_URL_FORGOT_PASSWORD;
export const URL_UPDATE_EMAIL = process.env.REACT_APP_URL_UPDATE_EMAIL;
export const URL_UPDATE_PASSWWORD = process.env.REACT_APP_URL_UPDATE_PASSWWORD;
export const URL_EMAIL_BY_LOGIN = process.env.REACT_APP_URL_EMAIL_BY_LOGIN;
export const URL_AUTHENTIFICATION = process.env.REACT_APP_URL_AUTHENTIFICATION;
export const URL_STATISTIQUE = process.env.REACT_APP_URL_STATISTIQUE;
export const URL_USER = process.env.REACT_APP_URL_USER;
export const URL_SIMULATION = process.env.REACT_APP_URL_SIMULATION;
export const URL_NOTIFICATION = process.env.REACT_APP_URL_NOTIFICATION;
export const URL_LOG = process.env.REACT_APP_URL_LOG;
export const URL_FOLDER = process.env.REACT_APP_URL_FOLDER;
export const URL_FILE = process.env.REACT_APP_URL_FILE;
export const URL_MEETING = process.env.REACT_APP_URL_MEETING;
export const URL_SHARE = process.env.REACT_APP_URL_SHARE;
export const URL_SHARE_DETAILS = process.env.REACT_APP_URL_SHARE_DETAILS;
export const URL_NOTIFY = process.env.REACT_APP_URL_NOTIFY;

export const SIZE_IMAGE_UPLOAD = 5368709120;
export const SIZE_DOC_UPLOAD = 5368709120;

export const PARAMS_NUMBERS = {
  shortFormat: true,
  shortFormatPrecision: 3,
  justification: "C",
  locales: "fr-FR",
  title: true,
};

export const PROFIL_USER = [
  { profil: 3, profilName: "Admin", link: "/main/dashboard" },
  { profil: 1, profilName: "Gestionnaire", link: "/client/dashboard" },
  { profil: 2, profilName: "Salarié", link: "/salarie/dashboard" },
];

export const MOIS_TABS = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
];

const get_annee = () => {
  let tab = [];
  for (let index = new Date().getUTCFullYear(); index >= 2016; index--) {
    tab.push(index.toString());
  }

  return tab;
};

export const ANNEE_TABS = get_annee();

export const refrech = async () => {
  axios
    .get(URL_AUTHENTIFICATION, getConfigHeader())
    .then((response) => {
      if (hasAuthentificated()) {
        addItem(LOCAL_STORAGE_NAME, response.data.token);
        Promise.resolve(response);
      } else {
        logout();
        Promise.reject("Non connecté");
      }
    })
    .catch((error) => {
      logout();
      Promise.reject(error);
    });
};

export const getConfigHeader = () => {
  const token = getToken();
  return {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      Authorization: `Bearer ${token}`,
    },
  };
};

export function getToken() {
  const token = getItem(LOCAL_STORAGE_NAME);
  if (token === undefined) return null;
  else return token;
}

export function verifyPassword(password) {
  let output = [];

  if (password.length < 8) {
    output.push("contenir au moins 8 caractères");
  }

  if (!password.match(/[a-z]/g)) {
    output.push("avoir au moins 01 lettre miniscule");
  }
  if (!password.match(/[A-Z]/g)) {
    output.push("avoir au moins 01 lettre majuscule");
  }
  if (!password.match(/[0-9]/g)) {
    output.push("contenir au moins 01 chiffre");
  }
  if (!password.match(/[#?!@$%^&*-]/)) {
    output.push(
      "doit contenir au moins 01 caractères spéciales (# ? ! @ $ % ^ & * -)"
    );
  }

  return output;
}

export function verifyDateMeeting(meeting) {
  let output = [];

  if (new Date(meeting.dateEnd) < new Date(meeting.dateStart)) {
    output.push("La date de fin doit être supérieure à la date de début.");
  }

  if (meeting.dateStart == meeting.dateEnd) {
    if (meeting.timeEnd < meeting.timeStart) {
      output.push(
        "Réunion programmé pour le même jour. L'heure de fin doit être supérieure à l'heure de début."
      );
    }
  }
  if (
    meeting.dateStart == meeting.dateEnd &&
    meeting.timeEnd == meeting.timeStart
  ) {
    output.push("Les dates et heures de début et de fin sont identiques.");
  }

  return output;
}
